module.exports = __webpack_public_path__ + "img/icon5.a4200517.svg";